import React, { useMemo } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Input,
  HStack,
  Spacer,
  Divider,
  Image,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import NoNotificationFound from "@root/assets/icons/noNotificationFound.svg";
import { DataTable } from "@root/components/datatable";
import { ColumnDef } from "@tanstack/react-table";

const notifications = [
  {
    name: "Network Upgrade - July 1",
    type: "Privacy Regulations",
    date: "2024-01-14",
  },
  {
    name: "Security Patch - July 10",
    type: "Intellectual Property",
    date: "2024-01-13",
  },
  {
    name: "Server Migration - July 20",
    type: "Content Moderation",
    date: "2024-01-12",
  },
  {
    name: "Database Optimization - August 5",
    type: "Digital Literacy",
    date: "2024-01-11",
  },
  {
    name: "Network Upgrade - July 1",
    type: "Privacy Regulations",
    date: "2024-01-14",
  },
  {
    name: "Security Patch - July 10",
    type: "Intellectual Property",
    date: "2024-01-13",
  },
  {
    name: "Server Migration - July 20",
    type: "Content Moderation",
    date: "2024-01-12",
  },
  {
    name: "Database Optimization - August 5",
    type: "Digital Literacy",
    date: "2024-01-11",
  },
  {
    name: "Network Upgrade - July 1",
    type: "Privacy Regulations",
    date: "2024-01-14",
  },
  {
    name: "Security Patch - July 10",
    type: "Intellectual Property",
    date: "2024-01-13",
  },
  {
    name: "Server Migration - July 20",
    type: "Content Moderation",
    date: "2024-01-12",
  },
  {
    name: "Database Optimization - August 5",
    type: "Digital Literacy",
    date: "2024-01-11",
  },
];

const cardBg = "white";
const cardBorder = "1px solid #E4EBF0";
const cardRadius = "16px";

const noNotificationFound = () => {
  return <Image src={NoNotificationFound} />;
};

const Notifications = () => {
  const { t } = useTranslation("common");

  const columns = useMemo<ColumnDef<any, any>[]>(
    () => [
      {
        header: t("notifications.name"),
        accessorKey: "name",
        cell: ({ row }) => <Text color="gray">{row.original.name}</Text>,
      },
      {
        header: t("notifications.type"),
        accessorKey: "type",
        cell: ({ row }) => row.original.type,
      },
      {
        header: t("notifications.datePosted"),
        accessorKey: "date",
        cell: ({ row }) => <Text color="gray">{row.original.date}</Text>,
      },
    ],
    [t]
  );

  return (
    <>
      <Box minH="100vh" width={"100%"} p={{ base: 2, md: 8 }}>
        {/* Header */}
        <Text fontSize="2xl" fontWeight="bold" mb={1}>
          {t("notifications.title")}
        </Text>
        <Text color="gray.500" mb={6}>
          {t("notifications.subtitle")}
        </Text>

        {/* Actions */}
        <Flex
          mb={4}
          gap={2}
          flexWrap={{ base: "wrap", md: "nowrap" }}
          align="center"
        >
          <HStack
            spacing={0}
            border="1px"
            borderRadius={"10px"}
            borderColor={"#1819B4"}
            width={"180px"}
            height={"40px"}
          >
            <Button flex="1" variant="link" height={"40px"}>
              {t("manageCourses.viewAll")}
            </Button>
            <Divider orientation="vertical" borderColor="blue.500" />
            <Button flex="1" variant="link" color="gray.500" height={"40px"}>
              {t("manageCourses.sort")}
            </Button>
          </HStack>
          <Spacer />
          <Input
            maxW="340px"
            placeholder={t("notifications.searchPlaceholder")}
            borderRadius="12px"
            bg="white"
          />
        </Flex>

        {/* DataTable */}
        <Box
          p={0}
          overflowX="auto"
          boxShadow="sm"
          bg={cardBg}
          border={cardBorder}
          borderRadius={cardRadius}
          minW="320px"
          maxH={"850px"}
          style={{ border: "1px solid #CDD6DC" }}
        >
          <DataTable
            data={notifications}
            columns={columns}
            showPagination={false}
            onRowSelectionChangeHandler={undefined}
            canEditRow={false}
            getRowId={(row: any) => row.name + row.date}
            renderSubComponent={undefined}
            getRowCanExpand={undefined}
            getRowSelected={undefined}
            onRowSelectionChange={undefined}
          />
          {/* No Notifications Found */}
          {!notifications?.length && (
            <Flex
              flexDir={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"700px"}
              width={"100%"}
              minW={"1000px"}
            >
              {noNotificationFound()}
              <Text fontWeight={600} fontSize={"24px"} mt={7}>
                {t("notifications.noActiveNotice")}
              </Text>
              <Text fontWeight={400} fontSize={"18px"} mt={1}>
                {t("notifications.noNotice")}
              </Text>
            </Flex>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Notifications;
